import {
  LayoutGrid,
  AppWindow,
  Users,
  Users2,
  Server,
  ScrollText,
  KeyRound,
  Settings,
  Network,
  HardDriveDownload,
  Boxes,
  Upload,
  BarChart3,
  Code,
  ShieldCheck,
  BookOpen,
  type LucideIcon,
} from "lucide-react";

export type Role = "admin" | "local" | "dev" | "client";

export type NavItem = {
  to: string;
  label: string;
  icon: LucideIcon;
  badge?: string;
  matchPrefix?: boolean;
};

export type NavGroup = {
  title: string;
  items: NavItem[];
};

export type RoleConfig = {
  role: Role;
  label: string;          // отображается в breadcrumb / профиле
  breadcrumb: string;     // "Администратор · Глобальный сервер"
  pageBase: string;       // "/admin"
  headerBadge?: { text: string; tone: "online" | "offline" };
  groups: NavGroup[];
};

export const roleConfigs: Record<Role, RoleConfig> = {
  admin: {
    role: "admin",
    label: "Глоб. админ",
    breadcrumb: "Администратор · Глобальный сервер",
    pageBase: "/admin",
    groups: [
      {
        title: "Корпоративный каталог",
        items: [
          { to: "/admin",          label: "Сводка",            icon: LayoutGrid },
          // Бейджи для admin'а проставляются динамически в Sidebar через getAdminSidebar().
          { to: "/admin/apps",     label: "Приложения",        icon: AppWindow,  matchPrefix: true },
          { to: "/admin/users",    label: "Пользователи",      icon: Users },
          { to: "/admin/groups",   label: "Группы",            icon: Users2 },
          { to: "/admin/locals",   label: "Локальные серверы", icon: Server },
          { to: "/admin/security", label: "Безопасность",      icon: ShieldCheck },
          { to: "/admin/analytics", label: "Аналитика",         icon: BarChart3 },
        ],
      },
      {
        title: "Audit",
        items: [
          { to: "/admin/log",      label: "Журнал",         icon: ScrollText },
          { to: "/admin/keys",     label: "Ключи подписи",  icon: KeyRound },
          { to: "/admin/docs",     label: "Документация",   icon: BookOpen },
          { to: "/admin/settings", label: "Настройки",      icon: Settings },
        ],
      },
    ],
  },
  local: {
    role: "local",
    label: "Лок. админ",
    breadcrumb: "Администратор · Локальный сервер",
    pageBase: "/local",
    headerBadge: { text: "msk-01 · онлайн", tone: "online" },
    groups: [
      {
        title: "Узел MSK-01",
        items: [
          { to: "/local",      label: "Состояние",        icon: LayoutGrid },
          { to: "/local/sync", label: "Синхронизация",    icon: Network },
          { to: "/local/cache", label: "Кэш приложений",  icon: Boxes },
          { to: "/local/log",  label: "Журнал",           icon: ScrollText },
        ],
      },
      {
        title: "Узел",
        items: [
          { to: "/local/net",      label: "Сеть",     icon: HardDriveDownload },
          { to: "/local/services", label: "Сервисы",  icon: Settings },
        ],
      },
    ],
  },
  dev: {
    role: "dev",
    label: "Разработчик",
    breadcrumb: "Разработчик",
    pageBase: "/dev",
    groups: [
      {
        title: "Разработчик",
        items: [
          { to: "/dev",        label: "Мои приложения", icon: AppWindow, badge: "4", matchPrefix: true },
          { to: "/dev/upload", label: "Загрузить APK",  icon: Upload },
          { to: "/dev/stats",  label: "Статистика",     icon: BarChart3 },
        ],
      },
      {
        title: "Аккаунт",
        items: [
          { to: "/dev/tokens",   label: "Токены API", icon: Code },
          { to: "/dev/settings", label: "Настройки",  icon: Settings },
        ],
      },
    ],
  },
  client: {
    role: "client",
    label: "Клиент Android",
    breadcrumb: "Конечный пользователь · Android",
    pageBase: "/client",
    groups: [],
  },
};

export function roleFromPath(pathname: string): Role {
  if (pathname.startsWith("/local"))  return "local";
  if (pathname.startsWith("/dev"))    return "dev";
  if (pathname.startsWith("/client")) return "client";
  return "admin";
}
